module.exports = __webpack_public_path__ + "img/about.32e712db.png";